import * as S from './Loader.styled';

function Loader() {
  return (
    <S.Container>
      <S.Loader />
    </S.Container>
  );
}

export default Loader;
